var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberFourIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 10C0.833252 4.91668 4.91658 0.833344 9.99992 0.833344C15.0833 0.833344 19.1666 4.91668 19.1666 10C19.1666 15.0833 15.0833 19.1667 9.99992 19.1667C4.91658 19.1667 0.833252 15.0833 0.833252 10ZM2.49992 10C2.49992 14.1667 5.83325 17.5 9.99992 17.5C14.1666 17.5 17.4999 14.1667 17.4999 10C17.4999 5.83334 14.1666 2.50001 9.99992 2.50001C5.83325 2.50001 2.49992 5.83334 2.49992 10Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1391_6770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 0.833344C4.91658 0.833344 0.833252 4.91668 0.833252 10C0.833252 15.0833 4.91658 19.1667 9.99992 19.1667C15.0833 19.1667 19.1666 15.0833 19.1666 10C19.1666 4.91668 15.0833 0.833344 9.99992 0.833344ZM9.99992 17.5C5.83325 17.5 2.49992 14.1667 2.49992 10C2.49992 5.83334 5.83325 2.50001 9.99992 2.50001C14.1666 2.50001 17.4999 5.83334 17.4999 10C17.4999 14.1667 14.1666 17.5 9.99992 17.5ZM6.36992 11.39V12.3933H10.5933V14.1667H11.8999V12.3933H12.9849V11.2383H11.8999V5.76668H10.2899L6.36992 11.39ZM7.89825 11.2383L10.6516 7.12001V11.2383H7.89825Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1391_6770)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#161616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberFourIcon);
export default __webpack_public_path__ + "static/media/number-four-icon.38c594a47db118792c605a17bc113338.svg";
export { ForwardRef as ReactComponent };